<script lang="ts">
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"

  interface Props {
    loading?: boolean
    error?: string | null
    userPresent?: boolean
    onRetry?: (() => void) | null
    loadingLabel?: string
    missingLabel?: string
    retryLabel?: string
  }

  let {
    loading = false,
    error = null,
    userPresent = false,
    onRetry = null,
    loadingLabel = "Benutzer wird geladen…",
    missingLabel = "Kein Benutzer gefunden.",
    retryLabel = "Erneut versuchen",
  }: Props = $props()
</script>

{#if loading}
  <div class="state-block">
    <p>{loadingLabel}</p>
  </div>
{:else if error}
  <div class="state-block">
    <p>{error}</p>
    {#if onRetry}
      <CTA type="secondaryButton" content={retryLabel} onClick={() => onRetry?.()} />
    {/if}
  </div>
{:else if !userPresent}
  <div class="state-block">
    <p>{missingLabel}</p>
  </div>
{/if}

<style lang="less">
  .state-block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;

    p {
      margin: 0;
    }
  }
</style>
